export default __webpack_public_path__ + "static/media/svg-mic.84747954.svg";